<div class="row compensate" *ngIf="loading" [ngClass]="{'grid': gridViewType, 'list': listViewType, 'small': size === 'small'}" >
  <div [class]="gridViewType ? parseGridClasses : 'col-12'" *ngFor="let item of productsArray">
    <div class="loader-item">
      <div class="loader-item_image">
        <div class="content"></div>
      </div>
      <div class="wrapper">
        <div class="loader-item_line productname"></div>
        <div class="loader-item_line productname"></div>
        <div class="loader-item_line productnumber"></div>
        <div class="loader-item_line packaging"></div>
        <div class="loader-item_line unit"></div>
        <div class="loader-item_line price"></div>
      </div>
    </div>
  </div>
</div>
